import { api } from '@/services';

import { IFaceIdProfileFacial } from '@/features/face-id-profiles/interfaces';
import { PROFILES_API_ENDPOINTS } from '@/constants';
import { ApiResponse } from '@/types';

const FaceIdProfileServiceDetails = {
  GetFaceIdProfileFacialData: async (id: string): Promise<ApiResponse<IFaceIdProfileFacial>> => {
    const response = await api.get(
      PROFILES_API_ENDPOINTS.PROFILES_FACIAL.replace(':profileId', id),
    );
    return response.data;
  },
};

export default FaceIdProfileServiceDetails;
